export const ProductComparison = "aa07f2fbed642772d24aecc48f5573edaec168c2150164dc3fc56fbdc295a255";